/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */

/**
 * * `hardware` - Hardware
 * * `installation` - Installation
 * * `materials` - Materials
 * * `labor` - Labor
 * * `other` - Other
 * * `maintenance` - Maintenance
 * * `support` - Support
 * * `repair` - Repair
 * * `emergency` - Emergency
 */
export type CategoryEnum = typeof CategoryEnum[keyof typeof CategoryEnum];


export const CategoryEnum = {
  hardware: 'hardware',
  installation: 'installation',
  materials: 'materials',
  labor: 'labor',
  other: 'other',
  maintenance: 'maintenance',
  support: 'support',
  repair: 'repair',
  emergency: 'emergency',
} as const;
